import { QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Drawer } from 'antd';
import { useContext, useMemo } from 'react';

import { CustomerLeadStepGuide } from 'src/components/customers/steps/CustomerLeadStepGuide';
import { CustomersContext } from 'src/pages/CustomersPage/CustomersPage.context';

type CustomerLeadGuideMobileProps = {
  className?: string;
};

export function CustomerLeadGuideMobile({ className }: Readonly<CustomerLeadGuideMobileProps>) {
  const { customerStepGuideKey, customerLeadProductSpecification, isMobileGuideOpened, toggleMobileGuideOpened } =
    useContext(CustomersContext);

  const isGuideAvailable = useMemo(
    () => !!customerStepGuideKey && !!customerLeadProductSpecification?.fieldGroupGuides[customerStepGuideKey],
    [customerStepGuideKey, customerLeadProductSpecification?.fieldGroupGuides]
  );

  if (!isGuideAvailable) {
    return null;
  }

  return (
    <div className={className}>
      <Drawer open={isMobileGuideOpened} placement="right" onClose={toggleMobileGuideOpened} destroyOnClose={false}>
        <CustomerLeadStepGuide />
      </Drawer>
      <Button type="link" icon={<QuestionCircleOutlined />} onClick={toggleMobileGuideOpened} />
    </div>
  );
}
